import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import { useSelector } from 'react-redux';
import * as vehicleProtectionSelectors from '@makemydeal/dr-dash-store/selectors/vehicleProtectionSelectors';
import { GAP_REMOVED_ALERT_MESSAGE, GAP_REMOVED_ALERT_TITLE } from '../constants';

export const GapRemovedForCashAlert = () => {
    const isGapRemovedForCash = useSelector(vehicleProtectionSelectors.getIsGapRemovedForCash);

    if (!isGapRemovedForCash) {
        return null;
    }

    return (
        <Alert type="caution" title={GAP_REMOVED_ALERT_TITLE} sx={{ marginBottom: '1rem' }}>
            <Typography variant="body-sm">{GAP_REMOVED_ALERT_MESSAGE}</Typography>
        </Alert>
    );
};
